import { Component, OnInit, EventEmitter } from '@angular/core';
import { UserService } from '../../../common/user.service';
import { MdSnackBar } from '@angular/material';

@Component({
  selector: 'app-change-admin-password',
  templateUrl: './change-admin-password.component.html',
  styleUrls: ['./change-admin-password.component.css','../../admin.css','../../../app.component.css'],
  providers: [UserService]
})
export class ChangeAdminPasswordComponent implements OnInit {

  oldPassword = '';
  password = '';
  confirmPassword = '';
  spinner: boolean = false;
  onChangePassword = new EventEmitter();

  constructor(private userService: UserService, private snackBar: MdSnackBar) { }

  ngOnInit() {
  }

  passwordFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && this.password!=this.confirmPassword)
   flag = false;
   return flag;
  }

  changePassword(){
   this.spinner = true;
   this.userService.changePassword({oldPassword:this.oldPassword, password:this.password, confirmPassword: this.confirmPassword}).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     {
      this.snackBar.open('Password updated successfully','',{duration:4000});
      this.onChangePassword.emit();
     }
     else
     this.snackBar.open(response.msg,'',{duration:4000});
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
  }


}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/profile/change-password/change-admin-password.component.ts